import React, { useState, useEffect } from 'react';

import { getUser } from 'API';

import MsgModal from 'Components/MsgModal';
import Loading from 'Components/Loading';

import Header from './Header';

export default function Main({ children = null }) {
  const [user, setUser] = useState({});
  const [popup, setPopup] = useState(null);
  const [loading, setLoading] = useState(0);
  
  
  const showLoading = () => setLoading(loading => loading + 1);
  const hideLoading = () => setLoading(loading => loading - 1);

  // if log is given, logs it to the console
  const setMsg = (msg = null, header = null, log = null) => {
    if (log !== null) console.log(log);

    setPopup({ msg, header });
  };

  useEffect(() => {
    (async () => {
      try {
        const user = await getUser();
        setUser(user);
      } catch (error) {
        console.error(error);
      }
    })();
  }, []);

  return (
    <div>
      <Header
        user={user}
      />
      {
        children
          ? React.cloneElement(
            children,
            {
              user, setMsg,
              showLoading, hideLoading,
            })
          : children
      }

      {
        loading > 0
          ? <Loading />
          : null
      }

      {
        popup
          ? (
            <MsgModal
              header={popup.header}
              msg={popup.msg}
              close={() => setPopup(null)}
            />
          ) : null
      }
    </div>
  );
}
